/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Job_Form_Enum_Staatsexam10Inputs */

const en_job_form_enum_staatsexam10 = /** @type {(inputs: Job_Form_Enum_Staatsexam10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`State Examination`)
};

const de_job_form_enum_staatsexam10 = /** @type {(inputs: Job_Form_Enum_Staatsexam10Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Staatsexamen`)
};

/**
* | output |
* | --- |
* | "State Examination" |
*
* @param {Job_Form_Enum_Staatsexam10Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const job_form_enum_staatsexam10 = /** @type {((inputs?: Job_Form_Enum_Staatsexam10Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Job_Form_Enum_Staatsexam10Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_job_form_enum_staatsexam10(inputs)
	return en_job_form_enum_staatsexam10(inputs)
});
export { job_form_enum_staatsexam10 as "job_form_enum_STAATSEXAM" }